import { useEffect } from 'react';
import { Modal } from 'src/components/Common/@electron/Modal';
import { RebatesModalInterface } from '../../../types';
import RebatesModalContent from './components/RebatesModalContent';

const RebatesModal = ({
  rebates,
  rebateIcon,
  sendRebateFoundModalAnalytics,
  onClose,
  primaryButtonText,
  secondaryButtonText,
  ...rest
}: RebatesModalInterface) => {
  useEffect(() => {
    if (rest.isOpen) {
      sendRebateFoundModalAnalytics?.(rebates[0]?.rebate);
    }
  }, [rest.isOpen]);
  return (
    <Modal onClose={onClose} {...rest}>
      <RebatesModalContent
        rebates={rebates}
        rebateIcon={rebateIcon}
        closeRebateModal={onClose}
        primaryButtonText={primaryButtonText}
        secondaryButtonText={secondaryButtonText}
      />
    </Modal>
  );
};

export default RebatesModal;
